import React, { useCallback } from 'react';
import { InputNumber } from 'antd';
import { FormikValues, useField } from 'formik';
import { InputNumberProps } from 'antd/lib/input-number';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface NumberInputProps<T extends FormikValues>
  extends Omit<InputNumberProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input numerico.
 */
export function NumberInput<T extends FormikValues>(
  props: NumberInputProps<T>
) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta, helpers] = useField(name);
  const inputProps = useInputProps(props);
  const handleChange = useCallback(
    (value: string | number | undefined) => {
      helpers.setValue(value === '' || value == null ? undefined : value);
    },
    [helpers.setValue]
  );

  return (
    <InputNumber
      {...field}
      onChange={handleChange}
      {...otherProps}
      {...inputProps}
    />
  );
}
